import style from "./styles";
import PropTypes from "prop-types";
import { formatPrice } from "../../helpers";

const AfterPayMessage = ({
  assetsUrl,
  premierDeliveryProposition,
  premierPrice,
}) => {
  const countriesWhiteList = ["AU", "NZ", "CC", "CX", "NF"];
  const currencyWhitelist = ["AUD", "NZD"];
  const currency = window.asos.webContext.getBrowseCurrency();
  const country = window.asos.webContext.getBrowseCountry();
  const isCurrencyValid = currencyWhitelist.includes(currency);
  const isValidCountry = countriesWhiteList.includes(country);

  if (premierPrice >= 20 && isValidCountry && isCurrencyValid) {
    const price = Math.round(premierPrice * 100);
    const installment = Math.ceil(price / 4) / 100;
    const formattedPrice =
      currency === "NZD"
        ? formatPrice(installment).replace("NZ", "NZD")
        : formatPrice(installment);

    return (
      <div className={style.AfterPayMessageContainer}>
        <p>
          <span>
            {premierDeliveryProposition.afterPayMessage.replace(
              "%price%",
              formattedPrice
            )}
          </span>
          <span>
            <img
              alt="Afterpay logo"
              src={`${assetsUrl}/premier-landing-page/img/svg/afterpay-logo.svg`}
            />
            <a
              href={premierDeliveryProposition.afterPayTermsAndConditionsLink}
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={style.afterpayInfo}
                alt="Afterpay terms and conditions"
                src={`${assetsUrl}/premier-landing-page/img/svg/information.svg`}
              />
            </a>
          </span>
        </p>
      </div>
    );
  }

  return null;
};

AfterPayMessage.propTypes = {
  assetsUrl: PropTypes.string,
  premierDeliveryProposition: PropTypes.shape({
    afterPayMessage: PropTypes.string,
    afterPayTermsAndConditionsLink: PropTypes.string,
  }),
  premierPrice: PropTypes.number,
};

export default AfterPayMessage;
